import { render, staticRenderFns } from "./NoticeRelease.vue?vue&type=template&id=3b195b1f&scoped=true&"
import script from "./NoticeRelease.vue?vue&type=script&lang=js&"
export * from "./NoticeRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b195b1f",
  null
  
)

export default component.exports